@let supplierInvoiceValue = supplierInvoice();
@let extraCosts = (supplierInvoiceValue?.customFees ?? 0) + (supplierInvoiceValue?.transport ?? 0);
<!--@let net = (supplierInvoiceValue?.netTotalItems ?? 0) + (supplierInvoiceValue?.netTotalTax ?? 0) + extraCosts;-->
<div class="d-flex flex-column w-100 totals-content">
  <div class="d-flex justify-content-between total-item">
    <div class="g-col-6 label-col">{{ "NET" | translate | capitalize }}</div>
    <div class="d-flex justify-content-end">
      <rc-value-mismatch
        [value]="supplierInvoice()!.netTotal"
        [calculatedValue]="calculatedNetTotal()"
        [label]="'NET'"
        [calculatedLabel]="'CALCULATED_ENTITY' | translate: { entity: 'NET' | translate }" />
      <div class="g-col-6 price-col">{{ supplierInvoice()!.netTotal | kendoNumber: decimalFormat }}</div>
    </div>
  </div>
  <div class="d-flex justify-content-between total-item indent">
    <div class="g-col-6 label-col">{{ "GOODS" | translate | capitalize }}</div>
    <div class="g-col-6 price-col">{{ supplierInvoiceValue?.netTotalItems ?? 0 | kendoNumber: decimalFormat }}</div>
  </div>
  <div class="d-flex justify-content-between total-item indent">
    <div class="g-col-6 label-col">{{ "TAXES" | translate | capitalize }}</div>
    <div class="g-col-6 price-col">{{ supplierInvoiceValue?.netTotalTax ?? 0 | kendoNumber: decimalFormat }}</div>
  </div>
  <div class="d-flex justify-content-between total-item indent">
    <div class="g-col-6 label-col">{{ "EXTRA_COSTS" | translate | capitalize }}</div>
    <div class="g-col-6 price-col">{{ extraCosts | kendoNumber: decimalFormat }}</div>
  </div>
  <div class="d-flex justify-content-between total-item">
    <div class="g-col-6 label-col">{{ "PAYMENT_DISCOUNT" | translate | capitalize }}</div>
    <div class="g-col-6 price-col">{{ supplierInvoiceValue?.paymentDiscountPercentage ?? 0 }}%</div>
  </div>
  <div class="d-flex justify-content-between total-item">
    <div class="g-col-6 label-col">{{ "TAX_BASE" | translate | capitalize }}</div>
    <div class="d-flex justify-content-end">
      <rc-value-mismatch
        [value]="supplierInvoice()!.taxableTotal"
        [calculatedValue]="calculatedTaxBase()"
        [label]="'TAX_BASE'"
        [calculatedLabel]="'CALCULATED_ENTITY' | translate: { entity: 'TAX_BASE' | translate }" />
      <div class="g-col-6 price-col">{{ supplierInvoiceValue?.taxableTotal ?? 0 | kendoNumber: decimalFormat }}</div>
    </div>
  </div>
  <div class="d-flex justify-content-between total-item">
    <div class="g-col-6 label-col">{{ "VAT" | translate | capitalize }}</div>
    <div class="g-col-6 price-col">{{ supplierInvoiceValue?.vatTotal ?? 0 | kendoNumber: decimalFormat }}</div>
  </div>
  <div class="totals-group">
    <div class="d-flex justify-content-between totals" #wrapper>
      <div rcSelectableOverflow [wrapperElement]="wrapper" class="label-col">{{ "TOTAL" | translate | capitalize }}</div>
      <div class="d-flex justify-content-end">
        <rc-value-mismatch
          [value]="supplierInvoice()!.total"
          [calculatedValue]="calculatedTotal()"
          [label]="'TOTAL'"
          [calculatedLabel]="'CALCULATED_ENTITY' | translate: { entity: 'TOTAL' | translate }" />
        <span class="prefix">{{ "EUR" | translate | uppercase }}</span>
        <span class="price-col">{{ supplierInvoiceValue?.total ?? 0 | kendoNumber: decimalFormat }}</span>
      </div>
    </div>
    <div class="d-flex justify-content-between total-item" #wrapper>
      <div rcSelectableOverflow [wrapperElement]="wrapper" class="label-col">{{ "PAYMENT_DISCOUNT" | translate | capitalize }}</div>
      <div class="d-flex justify-content-end">
        <rc-value-mismatch
          [value]="supplierInvoice()!.paymentDiscountAmount"
          [calculatedValue]="calculatedPaymentDiscount()"
          [label]="'PAYMENT_DISCOUNT'"
          [calculatedLabel]="'CALCULATED_ENTITY' | translate: { entity: 'PAYMENT_DISCOUNT' | translate }" />
        <span class="prefix">{{ "EUR" | translate | uppercase }}</span>
        <span class="price-col">{{ supplierInvoiceValue?.paymentDiscountAmount ?? 0 | kendoNumber: decimalFormat }}</span>
      </div>
    </div>
  </div>
</div>
